import RawHtml from '@components/RawHtml/RawHtml';
import Link from 'next/link';

import { WagtailImage, WagtailPage } from '@/types';
import { removeBaseUrl } from '@/utils/url';
import { Image } from '@components/Image';

type Props = {
  title: string;
  text: string;
  image: WagtailImage;
  button_page: WagtailPage | null;
  button_url: string | null;
  button_text: string;
};

function CTA(props: Props) {
  const { button_page, button_url, button_text, title, image, text } = props;

  return (
    <div className='streamfield cta'>
      <div className='container'>
        <div className='cta__box'>
          {title ? <div className='cta__box-header'>{title}</div> : ''}
          <div className='cta__box-text'>
            <RawHtml html={text} />
          </div>
          <Link
            href={button_page ? removeBaseUrl(button_page.full_url) : (button_url ?? '')}
            passHref
            className='button button--primary'
          >
            {button_text}
          </Link>
        </div>
      </div>
      <Image image={image} className='cta__image' fill sizes='100vw' />
    </div>
  );
}

export default CTA;
